import {html} from 'lit';

import {
	selectIomoColorTheme, selectIomoColorThemeIsSatisfied,
	selectIomoDesign,
	selectIomoDesignIsSatisfied,
	selectIomoHeadSectionIsSatisfied, selectIomoHousingSize,
	selectIomoHousingSizeIsSatisfied, selectIomoMiscSectionIsSatisfied, selectIomoOpticalSystem, selectIomoOpticalSystemIsSatisfied,
} from './iomoSelectors';
import {iomoDesignOptions, iomoHousingSizeOptions, iomoOpticalSystemOptions} from './iomoModel';
import {iomoColorEditionOptions} from './iomoMaterial';
import {setIomoAllHeadsData} from './iomoSlice';
import store from '../store';

export const iomoSectionConfig = [
	{
		id: 'iomoStart',
		label: {
			de: 'Konfigurator',
			en: 'Configurator',
			fr: 'Configurator',
		},
		visual: 'iomo3d',
		features: [],
		isSatisfied: () => true,
		isVisible: (state) => true,
		widgets: [
			html`
				<iomo-start></iomo-start>`,
		]
	},
	{
		id: 'iomoMounting',
		label: {
			de: 'Mounting Options',
			en: 'Mounting Options',
			fr: 'Mounting Options',
		},
		visual: 'iomoMounting',
		features: [],
		isSatisfied: () => true,
		isVisible: (state) => true,
		widgets: [
			html`
				<assistant-list-select
					.title=${{
						de: 'Which mounting option would you like to choose?',
						en: 'Which mounting option would you like to choose?',
						fr: 'Which mounting option would you like to choose?'
					}}
					.options=${iomoDesignOptions}
					action='iomo/setIomoDesign'
					.selected=${selectIomoDesign}
					.canBeSelected=${(state, id) => true}
					.isSatisfied=${selectIomoDesignIsSatisfied}></assistant-list-select>`,
		]
	},

	{
		id: 'iomoOpticalSystemSelect',
		label: {
			de: 'Optical System',
			en: 'Optical System',
			fr: 'Optical System',
		},
		visual: 'iomo3d',
		features: [],
		isSatisfied: () => true,
		isVisible: (state) => true,
		widgets: [
			html`
				<spc-attribute attributeId="root::Heads::Head::Housing::HS_HeadType" .hideDisabled=${true}></spc-attribute>

				<assistant-list-select
					.title=${{
						de: 'Welches Optisches System möchten Sie wählen?',
						en: 'Which optical system would you like to choose?',
						fr: 'Which optical system would you like to choose?'
					}}
					.options=${iomoOpticalSystemOptions}
					action='iomo/setIomoOpticalSystem'
					.selected=${selectIomoOpticalSystem}
					.canBeSelected=${() => true}
					.isSatisfied=${selectIomoOpticalSystemIsSatisfied}></assistant-list-select>

				<assistant-list-select
					.title=${{
						de: 'Welche Kopfgröße möchten Sie wählen?',
						en: 'Which head size do you like to choose?',
						fr: 'Which head size do you like to choose?'
					}}
					.options=${iomoHousingSizeOptions}
					.callback=${(value) => store.dispatch(setIomoAllHeadsData({key: 'housingSize', value: value}))}
					.selected=${selectIomoHousingSize}
					.canBeSelected=${() => true}
					.isSatisfied=${() => selectIomoHousingSizeIsSatisfied}></assistant-list-select>

			`,
		]
	},

	{
		id: 'iomoSurface',
		label: {
			de: 'Surface and Materials',
			en: 'Surface and Materials',
			fr: 'Surface and Materials',
		},
		visual: 'iomo3d',
		features: [],
		isSatisfied: () => true,
		isVisible: (state) => true,
		widgets: [
			html`
				<iomo-general-surface-settings></iomo-general-surface-settings>
			`,
		]
	},
	{
		id: 'iomoSingleDetails',
		label: {
			de: 'Details',
			en: 'Details',
			fr: 'Details',
		},
		visual: 'iomo3d',
		features: [],
		isSatisfied: () => true,
		isVisible: (state) => (selectIomoDesign(state) !== 'pole'),
		widgets: [
			html`
				<iomo-single-luminaire-settings></iomo-single-luminaire-settings>
			`,
		]
	},
	{
		id: 'iomoGeneralLayout',
		label: {
			de: 'Layout',
			en: 'Layout',
			fr: 'Disposition',
		},
		visual: 'iomo3d',
		features: [],
		isSatisfied: () => true,
		isVisible: (state) => (selectIomoDesign(state) === 'pole'),
		widgets: [
			html`
				<iomo-general-design-settings></iomo-general-design-settings>
			`,
		]
	},
	{
		id: 'iomoHeadDetail',
		label: {
			de: 'Leuchtenkopf Spezifikation',
			en: 'Luminaire head specification',
			fr: 'Spécification de la tête de luminaire',
		},
		visual: 'iomo3d',
		features: [],
		isSatisfied: selectIomoHeadSectionIsSatisfied,
		isVisible: (state) => (selectIomoDesign(state) === 'pole'),
		widgets: [
			html`
				<iomo-head-table></iomo-head-table>
				<iomo-head-tabs></iomo-head-tabs>
			`
		]
	},
	{
		id: 'misc',
		label: {
			de: 'Weitere Spezifikation',
			en: 'Further spezification',
			fr: 'Spécification supplémentaire',
		},
		visual: 'iomo3d',
		isSatisfied: selectIomoMiscSectionIsSatisfied,
		isVisible: (state) => true,
		features: [],
		widgets: [
			html`
				<iomo-general-controller-settings></iomo-general-controller-settings>
			`,
		]
	},
	{
		id: 'specsheet',
		label: {
			de: 'Datenblatt',
			en: 'Specsheet',
			fr: 'Specsheet',
		},
		visual: 'specsheet',
		features: [],
		isSatisfied: () => true,
		isVisible: (state) => true,
		widgets: null,
		theme: 'lightTheme',
		notInDashboard: true,
		simpleNavigation: true,
		notInNavigation: true,
	},
	{
		id: 'finalize',
		label: {
			de: 'Abschließen',
			en: 'Finalize',
			fr: 'Finalize',
		},
		visual: 'finalize',
		features: [],
		isSatisfied: () => true,
		isVisible: (state) => true,
		widgets: [
			html`

			`
		],
		theme: 'lightTheme',
		notInDashboard: true,
		noNavigation: true,
		notInNavigation: true,
	},
];

